import { useState, useEffect } from 'react';
import { getLocalStorage, setLocalStorage, removeLocalStorage } from '../../Core/Services/common';
import BizAgentWindow from './BizAgentWindow';
import './BizAgentWidget.scss';
import { useGlobalState } from '../../Core/Contexts/globalStateContext';
import { BizIcon } from '../../Core/Components/Mini/BizIcon';

const getLocalStorageSessionKey = (configSystemName: string, userId: number) =>
	`chatbot-session-id-${configSystemName}-${userId}`;

interface BizAgentWidgetProps {
	configSystemName: string;
	inlineMode?: boolean;
}

const BizAgentWidget: React.FC<BizAgentWidgetProps> = ({ configSystemName, inlineMode }) => {
	const [isOpen, setIsOpen] = useState(false);
	const [hasCheckedLocalSession, setHasCheckedLocalSession] = useState(false);
	const [sessionId, setSessionId] = useState<string | null>(null);
	const {
		state: { user },
	} = useGlobalState();

	const sessionKey = getLocalStorageSessionKey(configSystemName, user?.Id || 0);

	useEffect(() => {
		const savedSessionId = getLocalStorage(sessionKey);
		if (savedSessionId) {
			setSessionId(savedSessionId);
		}
		setHasCheckedLocalSession(true);
	}, [configSystemName, user?.Id]);

	if (!user) {
		return <BizIcon icon='LOADING' />;
	}

	const handleToggle = () => {
		setIsOpen(!isOpen);
	};

	const handleSessionCreate = (newSessionId: string) => {
		setSessionId(newSessionId);
		console.log('handleSessionCreate', newSessionId);
		setLocalStorage(sessionKey, newSessionId);
	};

	const handleSessionClear = () => {
		setSessionId(null);
		removeLocalStorage(sessionKey);
	};

	const wrapperClasses = `biz-agent-widget ${inlineMode ? 'inline-mode' : 'widget-mode'}`;

	return (
		<div className={wrapperClasses}>
			{(isOpen || inlineMode) && hasCheckedLocalSession && (
				<BizAgentWindow
					sessionId={sessionId}
					configSystemName={configSystemName}
					onClose={handleToggle}
					onSessionCreate={handleSessionCreate}
					onSessionClear={handleSessionClear}
					inlineMode={inlineMode}
				/>
			)}
			{!inlineMode && (
				<button
					className={`biz-agent-toggle-btn ${isOpen ? 'open' : ''}`}
					onClick={handleToggle}
					aria-label='Toggle BizAgent'
				>
					<svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
						<path
							d='M20 2H4C2.9 2 2 2.9 2 4V16C2 17.1 2.9 18 4 18H18L22 22V4C22 2.9 21.1 2 20 2ZM20 17.17L18.83 16H4V4H20V17.17Z'
							fill='currentColor'
						/>
						<circle cx='7' cy='9' r='1' fill='currentColor' />
						<circle cx='12' cy='9' r='1' fill='currentColor' />
						<circle cx='17' cy='9' r='1' fill='currentColor' />
					</svg>
				</button>
			)}
		</div>
	);
};

export default BizAgentWidget;
